export default __webpack_public_path__ + "static/media/j2.dff48238.png";